// Facts the site repeats in several places. Change them here, once.
export const PLAY_URL = 'https://play.google.com/store/apps/details?id=co.lordalexand.violeta';
export const APP_STORE_URL = 'https://apps.apple.com/ve/app/violeta-app/id6743567537';

// Where "Salir rápido" sends the person. A real link, so it also works without JavaScript.
export const QUICK_EXIT_URL = 'https://www.google.com/';

// Support phone of the app (not an emergency line). Same number the app uses for "Necesito ayuda".
export const SUPPORT_PHONE = '0414-217-5746';
export const SUPPORT_TEL = 'tel:+584142175746';
export const SUPPORT_WHATSAPP = 'https://wa.me/584142175746';

export const EMERGENCY_NUMBER = '911';

// The version people should see in Ajustes → Versión. Change it ONLY when Google Play shows the new version,
// or people on the previous one are told they are out of date before the update exists.
export const APP_VERSION = '4.2.7';

export type PhoneLine = { label: string; tel: string };

// The numbers in the app's helplines screen (4.2.7). On 7 Oct 2026 Tinta Violeta decided to keep only its
// own 4 lines plus 911: the other official numbers did not answer.
export const VIOLETA_LINES: PhoneLine[] = [
  { label: '0412-692-4020', tel: '+584126924020' },
  { label: '0412-692-4073', tel: '+584126924073' },
  { label: '0412-692-4804', tel: '+584126924804' },
  { label: '0412-692-4062', tel: '+584126924062' },
];

// Hours of Violeta's 4 lines, as Tinta Violeta confirmed on 13 Oct 2026 ("de 8 am a 8 pm"). They did not say
// which days, so no days are claimed. Outside these hours the site sends people to 911.
// The text ends in the abbreviation's own period, so sentences that use it add none.
export const VIOLETA_LINES_HOURS = 'de 8 a. m. a 8 p. m.';

// Credit line (fact-check item B14, decision D11). On 13 Oct 2026 Tinta Violeta asked to leave out
// "Proyecto RESPOND", because the app covers several projects.
export const SHOW_CREDIT_LINE = true;
export const CREDIT_LINE = 'Un proyecto de A.C. Tinta Violeta';
